const SPOTLIGHT_CDN_BASE = 'https://www.nerdwallet.com/cdn/banking/spotlight';

export const SPOTLIGHT_SPARKLE_SVG = `${SPOTLIGHT_CDN_BASE}/sparkle.svg`;
export const SPOTLIGHT_BANNER_SVG = `${SPOTLIGHT_CDN_BASE}/spotlight-banner.svg`;
